export function buyerAdvisoryResidentialCP1225() {
return [   // Release 2026-01-14 16:38:45
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 62.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 0,
   name: "Buyer Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 201.783,
   left: 179.346,
   width: 355.528,
   height: 11.527
}
,
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 228.619,
   left: 179.346,
   width: 355.528,
   height: 11.527
}
,
{
   page: 0,
   name: "Buyer Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 256.11,
   left: 179.346,
   width: 355.528,
   height: 11.527
}
,
{
   page: 1,
   name: "Buyer Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 1,
   name: "Buyer Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 2,
   name: "Buyer Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 2,
   name: "Buyer Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 3,
   name: "Buyer Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 3,
   name: "Buyer Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 4,
   name: "Buyer Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 4,
   name: "Buyer Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 5,
   name: "Buyer Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 5,
   name: "Buyer Brokerage Firm Name 13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 6,
   name: "Buyer Brokerage Firm Name 14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 174.12,
   width: 348.60,
   height: 10.20
}
,
{
   page: 6,
   name: "Buyer Brokerage Firm Name 15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 7,
   name: "Buyer Brokerage Firm Name 16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 174.12,
   width: 348.60,
   height: 11.40
}
,
{
   page: 7,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 653.24,
   left: 72.0,
   width: 212.52,
   height: 11.782
}
,
{
   page: 7,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 653.24,
   left: 294.36,
   width: 82.20,
   height: 11.782
}
,
{
   page: 7,
   name: "Buyer Brokerage Firm Name 17", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
] }
